module.exports = __webpack_public_path__ + "img/Maria Mak.8226b3b0.jpg";